import React, { useState, useEffect } from 'react';
import './FilterModal.css';
import closeIcon from '../../assets/closeIcon.png';
import { Slider } from '@mui/material';

const DEFAULT_RANGE = [0, 1000];

const FilterModal = ({ onClose, onApplyFilters, categories , filters  }) => {
  const [selectedCategory, setSelectedCategory] = useState(filters.category || '');
  const [priceRange, setPriceRange] = useState(filters.priceRange);
  const [minPrice, setMinPrice] = useState(filters.priceRange[0].toString());
  const [maxPrice, setMaxPrice] = useState(filters.priceRange[1].toString());

  useEffect(() => {
    const min = Number(minPrice);
    const max = Number(maxPrice);
    if (!isNaN(min) && !isNaN(max) && min <= max) {
      setPriceRange([min, max]);
    }
  }, [minPrice, maxPrice]);

  const handleMinPriceChange = (e) => {
    const value = e.target.value;
    if (value === '' || /^\d+$/.test(value)) {
      setMinPrice(value);
    }
  };

  const handleMaxPriceChange = (e) => {
    const value = e.target.value;
    if (value === '' || /^\d+$/.test(value)) {
      setMaxPrice(value);
    }
  };

  const handleSliderChange = (e, newValue) => {
    setPriceRange(newValue);
    setMinPrice(newValue[0].toString());
    setMaxPrice(newValue[1].toString());
  };

  const handleApplyFilters = () => {
    onApplyFilters({
      priceRange,
      category: selectedCategory,
    });
    onClose();
  };

  const handleReset = () => {
    setPriceRange(DEFAULT_RANGE);
    setMinPrice(DEFAULT_RANGE[0].toString());
    setMaxPrice(DEFAULT_RANGE[1].toString());
    setSelectedCategory('');
    onApplyFilters({
      priceRange: DEFAULT_RANGE,
      category: '',
    });
    onClose();
  };

  return (
    <div className="filter-modal-overlay" onClick={onClose}>
      <div className="filter-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="filter-modal-header">
          <h2>Filter Products</h2>
          <button className="close-button" onClick={onClose} aria-label="Close filter modal">
            <img src={closeIcon} alt="Close" style={{ width: '24px', height: '24px' }} />
          </button>
        </div>

        {/* Price Range Section */}
        <div className="filter-section">
          <h3>Price Range</h3>
          <div className="price-inputs">
            <div className="price-input-group">
              <label>Min Price</label>
              <input
                type="text"
                value={minPrice}
                onChange={handleMinPriceChange}
                placeholder="Min"
              />
            </div>
            <div className="price-input-group">
              <label>Max Price</label>
              <input
                type="text"
                value={maxPrice}
                onChange={handleMaxPriceChange}
                placeholder="Max"
              />
            </div>
          </div>

          <div className="price-slider">
            <Slider
              value={priceRange}
              size='small'
              onChange={handleSliderChange}
              
              valueLabelDisplay="auto"
              min={0}
              max={1000}
              step={10}
              sx={{ mt: 2  }}
            />
          </div>

          <div className="price-range-display">
            {priceRange[0]} TND - {priceRange[1]} TND
          </div>
        </div>

        {/* Category Section */}
        {categories && (
          <div className="filter-section">
            <h3>Category</h3>
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="category-select"
            >
              <option value="">All Categories</option>
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Buttons */}
        <div className="filter-actions">
          <button className="reset-button" onClick={handleReset}>
            Reset
          </button>
          <button className="apply-button" onClick={handleApplyFilters}>
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
